<template>
<section>
    <div class="modal animated fadeIn show oppay">
        <div class="modal-dialog modal-dialog-centered ">
            <div class="row">
                <div class="col-12">
                    <div class="opt-content card">
                        <div class="opt-content-wrapper active text-center">
                            <h1 class="text-center">4<span>0</span>4</h1>
                            <h3 class="mb-1">We've searched everywhere</h3>
                            <p>This page does not exit on our server <br>please check the link again</p>
                        </div>

                        <div class="form-group text-center mt-4">
                            <a href="https://onepipe.io" class="text-tiny">Onepipe.io</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
export default {
    name: 'NotFound',
}
</script>

<style scoped>
.opt-content-wrapper h1 {
    font-size: 50px;
    letter-spacing: 0.5rem
}

.opt-content-wrapper h1 span {
    color: #0E9BB9;
}
</style>
